export const PICTURE_CONTAINER_TYPE = {
  DOCUMENTS: 'documents',
  DAMAGE: 'damage',
  DAMAGE_LIST: 'damage_list',
};
